import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Dashboard from './pages/Dashboard'
import PlayerDetail from './pages/PlayerDetail'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout><Dashboard /></Layout>} />
        <Route path="/player/:playerId" element={<Layout><PlayerDetail /></Layout>} />
        {/* Redirect any unknown routes to dashboard */}
        <Route path="*" element={<Layout><Dashboard /></Layout>} />
      </Routes>
    </Router>
  )
}

export default App